export const options = [
  {
    key: '0',
    value: 0,
    text: 'All',
  },
  {
    key: '1',
    value: 1,
    text:
      'Parent First Name, Parent Last Name, Address 1, Address 2, City, State, Zip',
  },
  {
    key: '2',
    value: 2,
    text: 'Parent First Name, Parent Last Name, Address 1, City, State, Zip',
  },
  {
    key: '3',
    value: 3,
    text: 'Parent Last Name, Address 1, Address 2, City, State, Zip',
  },
  {
    key: '4',
    value: 4,
    text: 'Parent Last Name, Address 1, City, State, Zip',
  },
  {
    key: '5',
    value: 5,
    text: 'Parent First Name, Parent Last Name, Address 1',
  },
  {
    key: '6',
    value: 6,
    text: 'Address 1, Address 2, City, State, Zip',
  },
  {
    key: '7',
    value: 7,
    text: 'Address 1, City, State, Zip',
  },
  {
    key: '8',
    value: 8,
    text: 'Parent Last Name, Address 1',
  },
];



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/helpers/constants.js